import { render, staticRenderFns } from "./qrCodeLogin.vue?vue&type=template&id=0ffa81c2&scoped=true"
import script from "./qrCodeLogin.vue?vue&type=script&lang=js"
export * from "./qrCodeLogin.vue?vue&type=script&lang=js"
import style0 from "./qrCodeLogin.vue?vue&type=style&index=0&id=0ffa81c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa81c2",
  null
  
)

export default component.exports